<ng-container *transloco="let t;">
      <div class="detailFirstColumn">
        <label class="col-form-label">
          {{ t('Latest Activity table column name (document listing table) - Latest Activity') }}
        </label>
      </div>
      <div class="document-right-sidebar-get-link">
        <p class="mb-0 font-small-3 text-primary">
          {{ field?.value | dateFormat | async }}
        </p>
      </div>
    </ng-container>